var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 28L27 30L31.5 25.5M25.2019 36.6009C25.5297 36.5575 25.8607 36.6464 26.1218 36.8475L27.3251 37.7708C27.7228 38.0764 28.2761 38.0764 28.6727 37.7708L29.9215 36.812C30.1548 36.6331 30.4492 36.5542 30.7403 36.5931L32.3024 36.7986C32.799 36.8642 33.2779 36.5875 33.4701 36.1242L34.0712 34.6709C34.1834 34.3987 34.3989 34.1832 34.6711 34.0709L36.1243 33.4698C36.5876 33.2787 36.8643 32.7988 36.7987 32.3021L36.601 30.7966C36.5576 30.4688 36.6465 30.1377 36.8476 29.8766L37.7709 28.6733C38.0764 28.2755 38.0764 27.7222 37.7709 27.3256L36.812 26.0767C36.6332 25.8434 36.5543 25.549 36.5932 25.2579L36.7987 23.6957C36.8643 23.199 36.5876 22.7201 36.1243 22.5279L34.6711 21.9268C34.3989 21.8146 34.1834 21.5991 34.0712 21.3269L33.4701 19.8736C33.279 19.4102 32.799 19.1336 32.3024 19.1991L30.7403 19.4047C30.4492 19.4447 30.1548 19.3658 29.9226 19.188L28.6738 18.2292C28.2761 17.9236 27.7228 17.9236 27.3262 18.2292L26.0774 19.188C25.8441 19.3658 25.5496 19.4447 25.2586 19.4069L23.6965 19.2014C23.1998 19.1358 22.721 19.4125 22.5288 19.8758L21.9288 21.3291C21.8155 21.6002 21.6 21.8157 21.3289 21.9291L19.8757 22.529C19.4124 22.7213 19.1357 23.2001 19.2013 23.6968L19.4068 25.259C19.4446 25.5501 19.3657 25.8445 19.188 26.0767L18.2291 27.3256C17.9236 27.7233 17.9236 28.2767 18.2291 28.6733L19.188 29.9222C19.3668 30.1555 19.4457 30.4499 19.4068 30.741L19.2013 32.3032C19.1357 32.7999 19.4124 33.2787 19.8757 33.471L21.3289 34.0721C21.6011 34.1843 21.8166 34.3998 21.9288 34.672L22.5299 36.1253C22.721 36.5887 23.201 36.8653 23.6976 36.7998L25.2019 36.6009Z",
    stroke: "#0860C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyWelcome);
export default __webpack_public_path__ + "static/media/loyalty-welcome.752109db74c59b496fa8d5fed7af0df3.svg";
export { ForwardRef as ReactComponent };